import { useTheme } from '@emotion/react';
import { usePopover as usePopover$1 } from 'react-aria';
import { useOverlayContext } from '../overlay-context.js';

/**
 * Hook for building an accessible popover.
 *
 * @param options - Options for the hook.
 * @param ref - A ref to the underlying HTML element.
 */ function usePopover(options, ref) {
    const { containerPadding = 'md', crossOffset = 0, dismissibleByKeyboard = true, offset = '2xs' } = options;
    const theme = useTheme();
    const parseSpacing = (value)=>typeof value === 'string' ? theme.spacings[value] : theme.scales.base * (value ?? 0);
    const state = useOverlayContext();
    if (!state) throw new Error('[usePopover] hook must be used within an <OverlayProvider>.');
    const { placement, popoverProps, underlayProps } = usePopover$1({
        ...options,
        popoverRef: ref,
        containerPadding: parseSpacing(containerPadding),
        crossOffset: parseSpacing(crossOffset),
        offset: parseSpacing(offset),
        isKeyboardDismissDisabled: !dismissibleByKeyboard
    }, state);
    return [
        {
            ...state,
            placement
        },
        {
            backdropProps: underlayProps,
            popoverProps: popoverProps
        }
    ];
}

export { usePopover };
//# sourceMappingURL=use-popover.js.map
